import React from "react";

import {
  Card,
  CardBody,
  Content,
  Grid,
  GridItem,
  PageSection,
  Skeleton,
  Stack,
  StackItem
} from "@patternfly/react-core";

import {
  useParams
} from "react-router-dom";

import {
  useAnnouncement
} from "apps/school-site/features/announcements";


const AnnouncementDetailsPage = () => {
  const { postId } = useParams();

  const {
    announcement,
    loading,
    error
  } = useAnnouncement(postId);

  if (loading) {
    return (
      <PageSection isWidthLimited>
        <Grid>
          <GridItem
            span={12}
            md={8}
            mdOffset={2}
          >
            <Card isGlass>
              <CardBody>
                <Stack hasGutter>
                  <Skeleton width="55%" />
                  <Skeleton width="35%" />
                  <Skeleton width="100%" />
                  <Skeleton width="95%" />
                  <Skeleton width="80%" />
                </Stack>
              </CardBody>
            </Card>
          </GridItem>
        </Grid>
      </PageSection>
    );
  }

  if (error || !announcement) {
    return (
      <PageSection isWidthLimited>
        <Grid>
          <GridItem
            span={12}
            md={8}
            mdOffset={2}
          >
            <Content
              style={{
                textAlign: "center"
              }}
            >
              <h1>
                Ogłoszenie
              </h1>

              <p>
                Nie udało się pobrać ogłoszenia.
              </p>
            </Content>
          </GridItem>
        </Grid>
      </PageSection>
    );
  }

  const publishDate = announcement.publishedAt
    ? new Date(
        announcement.publishedAt
      ).toLocaleDateString(
        "pl-PL",
        {
          day: "numeric",
          month: "long",
          year: "numeric"
        }
      )
    : "";

  return (
    <PageSection isWidthLimited>
      <Stack hasGutter>
        <StackItem>
          <Grid>
            <GridItem
              span={12}
              md={8}
              mdOffset={2}
            >
              <Content
                style={{
                  textAlign: "center"
                }}
              >
                <h1>
                  {announcement.title}
                </h1>

                {publishDate && (
                  <p>
                    {publishDate}
                  </p>
                )}
              </Content>
            </GridItem>
          </Grid>
        </StackItem>

        <StackItem>
            <Grid>
                <GridItem
                span={12}
                md={4}
                mdOffset={4}
                >
                <Card isGlass>
                    <CardBody>
                    <Content>
                        <div
                        dangerouslySetInnerHTML={{
                            __html: announcement.content
                        }}
                        />
                    </Content>
                    </CardBody>
                </Card>
                </GridItem>
            </Grid>
        </StackItem>
      </Stack>
    </PageSection>
  );
};


export default AnnouncementDetailsPage;